export enum InboxCategories {
    General = 0,
	Platform = 1,
	Personal = 2,
}